<!-- last modified by AI tools on 2026-10-05 -->
<template>
  <div v-if="!isWeb" class="flex flex-col items-start gap-2">
    <div class="flex items-center gap-3 max-w-full">
      <!-- Long translations (e.g. Portuguese) wrap the disclosure link; the self-exclusion
           link keeps its full width instead of being pushed off-screen. -->
      <Button
        variant="link"
        :label="disclosureLabel"
        class="!text-xs !p-0 min-w-0 !justify-start !text-start"
        @click="onDisclosureClick"
      />
      <span aria-hidden="true" class="h-4 border-l border-outline-variant shrink-0" />
      <Button
        variant="link"
        :label="t('selfExclusion')"
        class="!text-xs !p-0 shrink-0 whitespace-nowrap"
        @click="onSelfExclusionClick"
      />
    </div>
    <div class="flex items-center gap-2 text-xs text-muted-color cursor-pointer" @click="onGfisClick">
      <p>{{ t('dataPoweredBy') }}</p>
      <img :src="logoSrc" :alt="t('gfisLogo')" class="h-[11px]" :aria-label="t('gfisLogo')" />
    </div>
  </div>
</template>

<script setup lang="ts">
import GFISLight from '../icons/GFIS_light.svg?url';
import GFISDark from '../icons/GFIS_dark.svg?url';
import { media, app } from '@ibgroup-tws-webapps/ratio.ui';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useNavigation } from '@/composables/useNavigation';
import { useProductHub } from '@/composables/useProductHub';

const { t } = useI18n();

const isWeb = computed(() => app.option?.clientPlatform === 'web' || app.option?.platform === 'web');

const { openUrl } = useNavigation();
const { isProductHubEnabled } = useProductHub();

const disclosureLabel = computed(() =>
  isProductHubEnabled.value ? t('predictionMarketsDisclosure') : t('forecastTraderDisclosure'),
);
const logoSrc = computed(() => (media.scheme === 'dark' ? GFISDark : GFISLight));

const onGfisClick = () => {
  openUrl('https://gfis.info');
};

const onDisclosureClick = () => {
  openUrl('tws://disclosures/4746');
};

const onSelfExclusionClick = () => {
  openUrl('sso://action=AccountSettings&config=PredictionMarketsSelfExclusion');
};
</script>
